import _ from 'lodash';
import * as types from '../constants/action-types';

const initialState = {
  data: [],
  isFetching: false,
  error: ''
};

export default function entitlements (state = initialState, action) {
  const { entitlementsArray, isFetching, error } = action;

  switch (action.type) {
  case types.ENTITLEMENTS_FETCH_REQUEST:
    return _.merge({}, state, {
      isFetching
    });
  case types.ENTITLEMENTS_FETCH_SUCCESS:
    return _.merge({}, state, {
      data: entitlementsArray,
      isFetching
    });

  case types.ENTITLEMENTS_FETCH_FAILURE:
    return _.merge({}, state, {
      error
    });

  default:
    return state;
  }
}
